import TrackingDataHelper from './trackingDataHelper';

export default {
  getServerData() {
    const server = {
      hostname: TrackingDataHelper.getElementAttribute(document.body, 'data-server'),
      elysium_version: window.start.siteDataV2.elysiumVersion,
    };
    return {server};
  },
};
